export const UPLOAD_INBOX_NOTIFICATION_URL = "inbox";
export const ALL_NOTIFICATIONS_TAB = "All";
export const DOWNLOADS_NOTIFICATIONS_TAB = "Downloads";
export const UPLOAD_NOTIFICATION_TABS = "Uploads";
export type NotificationDrawerTabs =
  | typeof ALL_NOTIFICATIONS_TAB
  | typeof DOWNLOADS_NOTIFICATIONS_TAB
  | typeof UPLOAD_NOTIFICATION_TABS;

export enum NotificationModuleIdentificationKeys {
  IS_DOWNLOAD_MODULE = "isDownloadAcknowledged",
  IS_UPLOAD_MODULE = "isUploadAcknowledged"
}

export const DATE_FORMAT_NOTIFICATIONS = "d MMM yyyy HH:mm";
